import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { appTitle } from "../common/GeneralConfigurations";
import AdnMessageError from "../common/adnMessage/AdnMessageError";
import ReportListForm from "./ReportListForm";
import {
  getOverdueFollowupEventsReport,
  getWelcomeReport,
} from "../../api/EmployeeFollowUpEventApi";
import { getConsultantEvaluationReport } from "../../api/QuizAPI/QuizAPI";
import { getConsultantsInAndOutReport } from "../../api/EmployeeApi";

const ManageReportListPage = () => {
  const { t } = useTranslation();

  const [loading, setLoading] = useState(false);
  const [reportList, setReportList] = useState([]);
  const [showParameterModal, setShowParameterModal] = useState(false);
  const [semesterValue, setSemesterValue] = useState(1);

  const REPORT_WELCOME = "Welcome";
  const REPORT_OVERDUE = "Overdue";
  const REPORT_IN_AND_OUT = "InAndOut";
  const REPORT_EVALUATION = "Evaluation";

  useEffect(() => {
    const REPORT_WELCOME_NAME = t("report.reports.welcome");
    const REPORT_OVERDUE_NAME = t("report.reports.overdue");
    const REPORT_IN_AND_OUT_NAME = t("report.reports.inAndOut");
    const REPORT_EVALUATION_NAME = t("report.reports.evaluation");

    document.title = `${appTitle} - ${t("report.title")}`;

    setReportList([
      { key: REPORT_WELCOME, name: REPORT_WELCOME_NAME },
      { key: REPORT_OVERDUE, name: REPORT_OVERDUE_NAME },
      { key: REPORT_IN_AND_OUT, name: REPORT_IN_AND_OUT_NAME },
      { key: REPORT_EVALUATION, name: REPORT_EVALUATION_NAME },
    ]);
  }, [t]);

  const generateReport = async (key) => {
    if (key === REPORT_WELCOME) {
      await generateWelcomeReport();
    } else if (key === REPORT_OVERDUE) {
      await generateOverdueFollowupEventsReport();
    } else if (key === REPORT_IN_AND_OUT) {
      await generateConsultantsInAndOutReport();
    } else if (key === REPORT_EVALUATION) {
      setShowParameterModal(true);
    }
  };

  const generateWelcomeReport = async () => {
    setLoading(true);
    await getWelcomeReport()
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const a = document.createElement("a");
        a.href = url;
        a.download = `${t("report.reports.welcome")}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        AdnMessageError(t("report.messages.couldNotGenerateReport"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const generateOverdueFollowupEventsReport = async () => {
    setLoading(true);
    await getOverdueFollowupEventsReport()
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const a = document.createElement("a");
        a.href = url;
        a.download = `${t("report.reports.overdue")}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        AdnMessageError(t("report.messages.couldNotGenerateReport"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const generateConsultantsInAndOutReport = async () => {
    setLoading(true);
    await getConsultantsInAndOutReport()
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const a = document.createElement("a");
        a.href = url;
        a.download = `${t("report.reports.inAndOut")}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        AdnMessageError(t("report.messages.couldNotGenerateReport"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const generateConsultantEvaluationReport = async (isFirstSemester) => {
    setLoading(true);
    await getConsultantEvaluationReport(isFirstSemester)
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
          })
        );
        const a = document.createElement("a");
        a.href = url;
        a.download = `${t("report.reports.evaluation")}.xlsx`;
        a.click();
        window.URL.revokeObjectURL(url);
      })
      .catch(() => {
        AdnMessageError(t("report.messages.couldNotGenerateReport"));
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleRunReport = async (e) => {
    const isFirstSemester = semesterValue === 1;
    await generateConsultantEvaluationReport(isFirstSemester);

    setShowParameterModal(false);
  };

  const handleBackParameterModal = (e) => {
    setShowParameterModal(false);
  };

  const handleSemesterChange = (event) => {
    setSemesterValue(event.target.value);
  };

  return (
    <ReportListForm
      loading={loading}
      reportList={reportList}
      generateReport={generateReport}
      handleRunReport={handleRunReport}
      showParameterModal={showParameterModal}
      handleBackParameterModal={handleBackParameterModal}
      handleSemesterChange={handleSemesterChange}
    />
  );
};

export default ManageReportListPage;
